import React, {Fragment} from "react";
import DigiPayPayNowButton from "./DigiPayPayNowButton";
import CardPaymentButton from "./CardPaymentButton";
import StitchPaymentButton from "./StitchPaymentButton";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import SFXButtonComponent from "../../SFXButtonComponent";
import UserSessionService from "../../../services/UserSessionService";

const DIGIPAY = 'DIGIPAY'
const SIKHONA_CARD = 'SIKHONA_CARD'
const STITCH = 'STITCH'

export default class PaymentOptions extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            transaction: props.transaction
        }
        this.hasActiveBankCard = UserSessionService.getCustomerProfile().hasActiveBankCard;

        this.howToPayLink = process.env.REACT_APP_HOW_TO_PAY_LINK;

        this.digiPayIsActive = false;
        this.sikhonaCardIsActive = false;
        this.stitchIsActive = false;
        this.props.paymentOptions.forEach(option => {
            if (option === DIGIPAY) {
                this.digiPayIsActive = true;
            }
            if (option === SIKHONA_CARD) {
                this.sikhonaCardIsActive = true;
            }
            if (option === STITCH) {
                this.stitchIsActive = true;
            }
        })
    }

    render() {
        return <Fragment>
            <div style={{textAlign: "center"}}>
                <h4>Pay Now</h4>
                <hr/>Disclaimer <br/>
                Please note we perform a bank account validation for this payment method.
                Your validation may result in a slight delay.
                <hr/>
                {this.sikhonaCardIsActive && this.hasActiveBankCard && this.renderCardPaymentButton()}
                {this.digiPayIsActive && this.renderDigiPayPayNow()}
                {this.stitchIsActive && this.renderStitchPayNow()}
                <hr/>
                For more ways to pay click <a className="moreWaysToPayLink" href={this.howToPayLink}>here</a>
            </div>
            {this.state.hasOpenAuth && this.renderHasOpenAuthModal()}
            {this.state.maxExceeded && this.renderMaxExceededModal()}
            {this.state.hasError && this.renderErrorModal()}
        </Fragment>

    }

    renderDigiPayPayNow() {
        return <Fragment>
            <div style={{marginBottom: "5px"}}>
                <DigiPayPayNowButton
                    transactionId={this.state.transaction.transactionId}
                />
            </div>
        </Fragment>
    }

    renderCardPaymentButton() {
        return <Fragment>
            <div style={{marginBottom: "5px"}}>
                <CardPaymentButton
                    paymentReference={this.state.transaction.paymentReference}
                    amount={this.state.transaction.amount}
                    transactionId={this.state.transaction.transactionId}
                    isMobile={this.props.isMobile}
                    onError={this.handleError.bind(this)}
                    onPaymentSuccess={this.onPaymentSuccess.bind(this)}
                />
            </div>
        </Fragment>
    }

    renderStitchPayNow() {
        return <Fragment>
            <div style={{marginBottom: '5px'}}>
                <StitchPaymentButton
                    transaction={this.props.transaction}
                    isMobile={this.props.isMobile}
                    onError={this.handleError.bind(this)}
                />
            </div>
        </Fragment>
    }

    handleError(error) {
        if (error.message === 'AUTHORISATION_ALREADY_OPEN') {
            this.setState({
                hasOpenAuth: true
            })
        } else if (error['error-code'] === 'EXCEEDS_MAXIMUM_AMOUNT') {
            this.setState({
                maxExceeded: true,
                message: error.message
            })
        } else {
            this.setState({
                hasError: true,
                error: error
            })
        }
    }

    renderHasOpenAuthModal() {
        return <Fragment>
            <Modal isOpen={true} className={'modal-primary modal-md'}>
                <ModalHeader className={this.className + '_modal_header'}>
                    Error Occurred
                </ModalHeader>
                <ModalBody>
                    It seems someone is already trying to pay for this transaction. <br/>
                    Please wait 5 minutes and try again.
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent color="secondary" onClick={
                        () => {
                            this.setState({hasOpenAuth: false})
                        }
                    }>
                        OK
                    </SFXButtonComponent>
                </ModalFooter>
            </Modal>
        </Fragment>
    }

    renderMaxExceededModal() {
        return <Fragment>
            <Modal isOpen={true} className={'modal-primary modal-md'}>
                <ModalHeader className={this.className + '_modal_header'}>
                    Maximum payment amount exceeded
                </ModalHeader>
                <ModalBody className="stitchAmountOver500">
                    <span className="stitchAmountOver500Text">{this.state.message}</span> for this payment method. <br/>
                    Please either pay at one of our stores or reduce the transaction value to less than this amount
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent color="secondary" onClick={
                        () => {
                            this.setState({maxExceeded: false})
                        }
                    }>
                        OK
                    </SFXButtonComponent>
                </ModalFooter>
            </Modal>
        </Fragment>;
    }

    renderErrorModal() {
        return <Fragment>
            <Modal isOpen={true} className={'modal-primary modal-md'}>
                <ModalHeader className={this.className + '_modal_header'}>
                    Error Occurred
                </ModalHeader>
                <ModalBody>
                    {this.state.error.message}
                    <br/>
                    {
                        this.state.error.errors && Array.isArray(this.state.error.errors) &&
                        <ul>
                            {this.state.error.errors.map(singleError => {
                                return <li>
                                    {singleError}
                                </li>
                            })
                            }
                        </ul>
                    }
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent color="secondary" onClick={
                        () => {
                            this.setState({hasError: false})
                        }
                    }>
                        OK
                    </SFXButtonComponent>
                </ModalFooter>
            </Modal>
        </Fragment>;
    }

    onPaymentSuccess() {
        if (this.props.doRefresh) {
            this.props.doRefresh()
        }
    }

}
